import { render, staticRenderFns } from "./vipDaysDialog.vue?vue&type=template&id=1007cc6c"
import script from "./vipDaysDialog.vue?vue&type=script&lang=ts"
export * from "./vipDaysDialog.vue?vue&type=script&lang=ts"
import style0 from "./vipDaysDialog.vue?vue&type=style&index=0&id=1007cc6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports